import React, { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { get } from '../../utils/axios';
import { Col } from 'react-bootstrap';
import Statsbox from '../stats-box';
import { Link } from 'react-router-dom';

const BatteriesCount = (): JSX.Element => {
  const [customersCount, setCustomersCount] = useState(0);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    get('/customers/count').then((response: AxiosResponse) => {
      const count: number = response.data.data.count;

      setCustomersCount(count);

      setFetching(false);
    });
  }, []);

  return (
    <Col xs={6} md={3}>
      <Link to="/customers">
        <Statsbox
          iconColorClass="text-info"
          bgClass="dark"
          fetching={fetching}
          title={customersCount}
          caption="Total customers"
          faIconName="fas fa-users"
        />
      </Link>
    </Col>
  );
};

export default BatteriesCount;
